// extracted by mini-css-extract-plugin
module.exports = {"leadItem":"LeadCard_leadItem__3IC0f","actionLink":"LeadCard_actionLink__1FOGA","skeletonListItem":"LeadCard_skeletonListItem__YUcSu"};